import { useIntl } from 'react-intl';

import { useFeatureFlag } from '@order/LaunchDarkly';

export const useBagDisclosure = (props: UseBagDisclosureProps) => {
  const {
    orderChannel,
    showDeliveryFeeDisclosure,
    deliveryMinSubtotal,
    deliveryFee,
    deliveryDisclosure,
    outpostDisclosure,
  } = props;

  const { formatNumber } = useIntl();
  const isBagDisclosureEnabled = useFeatureFlag(
    'CELS-4097-enable-new-bag-disclosure',
  );

  const canShowDisclosure = isBagDisclosureEnabled && showDeliveryFeeDisclosure;

  if (canShowDisclosure && orderChannel === 'delivery') {
    const minimum = formatNumber(deliveryMinSubtotal / 100, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    const fee = formatNumber(deliveryFee / 100, {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

    return deliveryDisclosure
      .replaceAll('{minimum}', minimum)
      .replaceAll('{fee}', fee);
  }

  if (canShowDisclosure && orderChannel === 'outpost') {
    return outpostDisclosure;
  }
};

// ─── Types ───────────────────────────────────────────────────────────────────

type UseBagDisclosureProps = {
  orderChannel: 'pickup' | 'delivery' | 'outpost' | 'kiosk';
  showDeliveryFeeDisclosure: boolean; // from restaurant/salesforce
  deliveryMinSubtotal: number;
  deliveryFee: number;
  deliveryDisclosure: string;
  outpostDisclosure: string;
};
